// utils/message.js

const createMessage = (text, type = 'info', duration = 2000) => {
  const messageBox = document.createElement('div')
  messageBox.className = `custom-message custom-message-${type}`
  messageBox.innerText = text

  document.body.appendChild(messageBox)

  // 强制触发浏览器重绘以启动动画
  // eslint-disable-next-line no-unused-expressions
  window.getComputedStyle(messageBox).opacity

  messageBox.style.transform = 'translateY(0)'
  messageBox.style.opacity = '1'

  setTimeout(() => {
    messageBox.style.transform = 'translateY(-20px)'
    messageBox.style.opacity = '0'
    messageBox.addEventListener('transitionend', () => {
      messageBox.remove()
    })
  }, duration)
}

export const Message = {
  success (msg, duration) {
    createMessage(msg, 'success', duration)
  },
  error (msg, duration) {
    createMessage(msg, 'error', duration)
  },
  info (msg, duration) {
    createMessage(msg, 'info', duration)
  }
}
